import { render, staticRenderFns } from "./authredirect.vue?vue&type=template&id=3f50518f&scoped=true"
import script from "./authredirect.vue?vue&type=script&lang=js"
export * from "./authredirect.vue?vue&type=script&lang=js"
import style0 from "./authredirect.vue?vue&type=style&index=0&id=3f50518f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f50518f",
  null
  
)

export default component.exports